export default function LegalSections({ sections, effective }) {
  return (
    <section className="py-20 bg-[var(--ec-cream)]">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 space-y-10">
        <p className="text-sm text-[var(--ec-charcoal)]/75" data-testid="legal-effective-date">{effective}</p>
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="font-display text-2xl text-[var(--ec-navy)]">{s.h}</h2>
            {s.p.map((t) => (
              <p key={t} className="mt-3 text-[var(--ec-charcoal)]/85 leading-relaxed">{t}</p>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
